import React from "react";
import { cx } from "../utils";

/**
 * CcAlertList — vertical stack of alert cards with scroll-friendly layout.
 */
const CcAlertList = ({ children, className, emptyState = null }) => {
  const hasChildren = React.Children.count(children) > 0;

  if (!hasChildren && emptyState) {
    return emptyState;
  }

  return (
    <div className={cx("cc-alert-list", className)}>
      <div className="cc-alert-list__items">{children}</div>
    </div>
  );
};

export default CcAlertList;
